module.exports = __webpack_public_path__ + "img/StyleDesign.438b69bb.svg";